import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../../../../contexts/AuthContext";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../../../utils/hooks/useActionCallback";
import {
  OptInsPatchCheckMapper,
  OptInsPatchSyncLenderMapper,
} from "../../../../../../utils/mappers/OptInsPatchMappers";
import { getModuleOptIns } from "../../../../../../utils/optInsHelpers";
import {
  REGISTRIES_WITH_ORDERING_NEEDED,
  SUMMARY_AND_ADJUST_LOAN_OPTINS_TYPES_LIST,
} from "../../config";

export default function useGDPRHandler() {
  const {
    state: { optIns, loan, participant },
    dispatch,
  } = useContext(ProcessContext);
  const {
    state: { agent },
  } = useContext(AuthContext);

  const { custom_registry } = agent;

  const [state, setState] = useState({
    optInsArray: [],
    areOptInsSynced: false,
  });

  const { optInsArray, areOptInsSynced } = state;

  useEffect(() => {
    requestPatchSyncLenderOptInsAndSequence();
  }, []);

  useEffect(() => {
    if (optIns && areOptInsSynced) {
      getAndSetModuleOptIns();
    }
  }, [optIns, areOptInsSynced]);

  useActionCallback(
    "REQUEST_PATCH_SYNC_LENDER_OPTINS_AND_SEQUENCE_FULFILLED",
    () => {
      sortOptInsIfNeededAndSetOptIns(optInsArray);
      setState((s) => ({ ...s, areOptInsSynced: true }));
    }
  );

  const requestPatchSyncLenderOptInsAndSequence = () => {
    const dataToSend = OptInsPatchSyncLenderMapper.hydrate({
      id: optIns.id,
      loanId: loan.id,
      borrowerId: participant.participantId,
    });
    dispatch({
      type: "REQUEST_PATCH_SYNC_LENDER_OPTINS_AND_SEQUENCE",
      payload: dataToSend,
    });
  };

  const getAndSetModuleOptIns = () => {
    const moduleOptIns = getModuleOptIns(
      SUMMARY_AND_ADJUST_LOAN_OPTINS_TYPES_LIST,
      optIns
    );

    const isAnyOptInNotCompleted = moduleOptIns.some(
      (optIn) => optIn.checked === null
    );

    isAnyOptInNotCompleted
      ? sortOptInsIfNeededAndSetOptIns(moduleOptIns)
      : setState((s) => ({ ...s, optInsArray: [] }));
  };

  const sortOptInsIfNeededAndSetOptIns = (optInsConditionsArray) => {
    const isOptInsSortingNeeded =
      REGISTRIES_WITH_ORDERING_NEEDED.includes(custom_registry);
    const optInsArray = isOptInsSortingNeeded
      ? optInsConditionsArray.sort((a, b) => {
          //TODO --> review order in prod if goes with name or description
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        })
      : optInsConditionsArray;

    setState((s) => ({ ...s, optInsArray }));
  };

  const submitOptInsConsents = (optInsValues) => {
    const conditions_check = [];
    if (optInsValues) {
      Object.keys(optInsValues).map((value) => {
        optInsArray.map((optIn) => {
          optIn.name === value &&
            conditions_check.push({
              id: optIn.condition_id,
              check: optInsValues[value],
            });
        });
      });
    }
    const dataToSend = OptInsPatchCheckMapper.hydrate({
      id: optIns.id,
      conditions_check,
      loanId: loan.id,
      borrowerId: participant.participantId,
    });
    dispatch({
      type: "REQUEST_PATCH_OPTIN_BY_ID_CONDITIONS_CHECK_IN_AND_SEQUENCE",
      payload: dataToSend,
    });
  };

  return {
    submitOptInsConsents,
    optInsArray,
    areOptInsSynced,
  };
}
